import { ChangeEvent, FC, ReactNode, useEffect, useState } from 'react'
import { MagnifyingGlassIcon } from '@heroicons/react/16/solid'
import { CategoryState, ComponentState, SideoverState } from '@/states'

const GridSearch: FC = (): ReactNode => {
    const { Loading: CategoriesLoading } = CategoryState()
    const { Loading: SideoverLoading } = SideoverState()
    const { Filters, Loading, SetState: ComponentSetState } = ComponentState()

    const [search, setSearch] = useState<string>(Filters?.Term || '')
    const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null)

    const HandleChange = (value: string, target: keyof ComponentFilterClientTypes) => {
        if (!Loading && !SideoverLoading && !CategoriesLoading) {
            const filters = structuredClone(Filters)
            filters[target] = value

            ComponentSetState({ Filters: filters })
        }
    }

    const HandleSearch = (e: ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value
        setSearch(newValue)

        if (timeoutId) clearTimeout(timeoutId)

        setTimeoutId(setTimeout(() => HandleChange(newValue, 'Term'), 500))
    }

    useEffect(() => {
        if (Filters?.Term === '') setSearch('')
    }, [Filters])

    return (
        <div className='relative w-full mr-2 md:mr-2 md:w-[30%]'>
            <div className='absolute inset-y-0 rtl:inset-r-0 start-0 flex items-center ps-3'>
                <MagnifyingGlassIcon className='flex-shrink-0 w-5 h-5 text-[#CDD5DA]' />
            </div>

            <input
                type='text'
                value={search}
                onChange={HandleSearch}
                className='select-none block p-2 px-2 py-[9px] ps-10 border-[#4A4A4A] w-full bg-[#4A4A4A] placeholder:text-[#97999b] text-sm rounded-md text-[#EBEBEB]'
                placeholder='Search components...'
                disabled={CategoriesLoading || SideoverLoading}
            />
        </div>
    )
}

export default GridSearch
